// client/src/pages/Login.js

import React from 'react';
import { Link } from 'react-router-dom';

const Login = () => {
  return (
    <section className="bg-soft-earth min-h-screen flex items-center justify-center px-6 py-16">
      <div className="bg-white shadow-lg rounded-lg p-10 max-w-xl w-full text-center">
        <h1 className="text-3xl font-bold text-primary mb-4">
          Login Coming Soon
        </h1>
        <p className="text-lg text-gray-700 mb-6">
          We’re working hard to bring secure member access to the Better Turns
          Co-op. Soon, you’ll be able to log in to manage your store, access
          co-op analytics, and collaborate with fellow retailers.
        </p>
        <p className="text-base text-gray-600 mb-6">
          In the meantime, feel free to explore our resources or{' '}
          <Link
            to="/contact"
            className="text-sunshine-yellow font-semibold hover:text-warm-orange"
          >
            reach out to get involved
          </Link>
          .
        </p>
        <Link
          to="/"
          className="inline-block bg-primary text-white font-semibold px-6 py-3 rounded hover:bg-leaf-green transition"
        >
          Return Home
        </Link>
      </div>
    </section>
  );
};

export default Login;
